const routerMobile = {
  path: "/mobile",
  name: "mobileHome",
  redirect: "/mobile/index",
  component: () => import("@/viewsMobile/home.vue"),
  children: [
    {
      path: "index",
      name: "mobile_index",
      component: () => import("@/viewsMobile/index/index.vue"),
      meta: { name: "首页" }
    },
    {
      path: "handsIdentify",
      name: "handsIdentifyMobile",
      component: () => import("../views/handsIdentify"),
      meta: { name: "手势识别", nameEn: "handsIdentifyMobile" }
    },
    {
      path: "products",
      name: "mobile_products",
      component: () => import("@/viewsMobile/products/index.vue"),
      meta: { name: "产品类别" }
    },
    {
      path: "productsNo/:no",
      name: "mobile_productsNo",
      component: () => import("@/viewsMobile/productsNo/index.vue"),
      meta: { name: "产品列表" }
    },
    {
      path: "application",
      name: "mobile_application",
      component: () => import("@/viewsMobile/application/index.vue"),
      meta: { name: "应用" }
    },
    {
      path: "productInfo/:goodsNo",
      name: "mobile_productInfo",
      component: () => import("@/viewsMobile/productInfo/index.vue"),
      meta: { name: "商品详情" }
    },
    {
      path: "aboutUS",
      name: "mobile_aboutUS",
      component: () => import("@/viewsMobile/aboutUS/index.vue"),
      meta: { name: "关于瑞杰" }
    },
    {
      path: "enterpriseNews",
      name: "mobile_enterpriseNews",
      component: () => import("@/viewsMobile/enterpriseNews/index.vue"),
      meta: { name: "新闻资讯" }
    },
    {
      path: "newConent/:comNo",
      name: "mobile_newConent",
      component: () => import("../viewsMobile/enterpriseNews/newConent.vue"),
      meta: { name: "新闻详情" }
    },
    {
      path: "bannerContent/:advNo",
      name: "mobile_bannerContent",
      component: () => import("@/viewsMobile/bannerContent"),
      meta: { name: "广告详情" }
    },
    {
      path: "userPersonal",
      name: "mobile_userPersonal",
      component: () => import("@/viewsMobile/userPersonal"),
      meta: { name: "广告详情" }
    },
    {
      path: 'shopCart',
      name: 'mobile_shopCart',
      component: () => import('@/viewsMobile/shopCart'),
      meta: {title: '商城购物车', keepAlive: false}
    },
    {
      path: 'submitOrder',
      name: 'mobile_submitOrder',
      component: () => import('@/viewsMobile/submitOrder'),
      meta: {title: '订单提交', keepAlive: false}
    },
    {
      path: 'payment',
      name: 'mobile_payment',
      component: () => import('@/viewsMobile/payment'),
      meta: {title: '订单结算', keepAlive: false}
    },
    {
      path: 'persionCenter',
      name: 'mobile_persionCenter',
      component: () => import('@/viewsMobile/persionCenter'),
      meta: {title: '个人中心', keepAlive: true}
    },
    {
      path: 'userPersion',
      name: 'mobile_userPersion',
      component: () => import('@/viewsMobile/userPersion'),
      meta: {title: '个人信息', keepAlive: true}
    },
    {
      path: 'myOrders',
      name: 'mobile_myOrders',
      component: () => import('@/viewsMobile/myOrders'),
      meta: {title: '订单列表', keepAlive: false}
    },
    {
      path: 'orderDetails',
      name: 'mobile_orderDetails',
      component: () => import('@/viewsMobile/orderDetails'),
      meta: {title: '订单详情', keepAlive: false}
    },
    {
      path: 'recharge/:orderNo/:subOrderNo/:orderChildOrderNo',
      name: 'mobile_recharge',
      component: () => import('@/viewsMobile/recharge'),
      meta: {title: '充值', keepAlive: false}
    },

    {
      path: 'address',
      name: 'mobile_address',
      component: () => import('@/viewsMobile/address'),
      meta: {title: '收货地址', keepAlive: true}
    },

    {
      path: 'bindPhone',
      name: 'mobile_bindPhone',
      component: () => import('@/viewsMobile/bindPhone'),
      meta: {title: '绑定手机', keepAlive: true}
    },
    {
      path: "UOMValidate",
      name: "mobile_UOMValidate",
      component: () => import("@/viewsMobile/UOMValidate"),
      meta: {title: 'UON验证', keepAlive: true}
    },





  ],
};

export default routerMobile;



// WEBPACK FOOTER //
// ./src/router/routerMobile.js